import {
    CallOutlined,
    MessageOutlined,
    ShareOutlined,
    VideoCallOutlined,
} from '@mui/icons-material';
import { Button, ButtonProps, Stack, SvgIconProps } from '@mui/material';

interface ContactActionsProps {
    buttonProps?: ButtonProps;
    iconProps?: SvgIconProps;
}

const ContactActions = ({ buttonProps, iconProps }: ContactActionsProps) => {
    return (
        <Stack direction="row" spacing={1}>
            <Button variant="tonal" color="primary" {...buttonProps}>
                <CallOutlined color="primary" {...iconProps} />
            </Button>
            <Button variant="tonal" color="primary" {...buttonProps}>
                <MessageOutlined color="primary" {...iconProps} />
            </Button>
            <Button variant="tonal" color="primary" {...buttonProps}>
                <VideoCallOutlined color="primary" {...iconProps} />
            </Button>
            <Button variant="tonal" color="primary" {...buttonProps}>
                <ShareOutlined color="primary" {...iconProps} />
            </Button>
        </Stack>
    );
};

export default ContactActions;
